import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'smart-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {
    year : Date = new Date();

    constructor() { }

    ngOnInit() {}
}
